var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 76.2084,
    cy: 98.3334,
    r: 45.2084,
    fill: "#D1D3D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M432.908 410.939L309.905 289.396L285.549 314.044L408.552 435.588L432.908 410.939Z",
    fill: "#97999B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M443.017 420.914L352.177 331.151L327.905 355.714L418.746 445.477L443.017 420.914Z",
    fill: "#54585A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200.888 350.523C285.51 350.523 354.11 281.923 354.11 197.301C354.11 112.678 285.51 44.0781 200.888 44.0781C116.265 44.0781 47.665 112.678 47.665 197.301C47.665 281.923 116.265 350.523 200.888 350.523Z",
    fill: "#97999B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203.76 317.917C270.638 317.917 324.854 263.702 324.854 196.823C324.854 129.945 270.638 75.7295 203.76 75.7295C136.882 75.7295 82.666 129.945 82.666 196.823C82.666 263.702 136.882 317.917 203.76 317.917Z",
    fill: "#F5F5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.76 311.459C267.071 311.459 318.396 260.135 318.396 196.823C318.396 133.512 267.071 82.1878 203.76 82.1878C140.448 82.1878 89.1244 133.512 89.1244 196.823C89.1244 260.135 140.448 311.459 203.76 311.459ZM324.854 196.823C324.854 263.702 270.638 317.917 203.76 317.917C136.882 317.917 82.666 263.702 82.666 196.823C82.666 129.945 136.882 75.7295 203.76 75.7295C270.638 75.7295 324.854 129.945 324.854 196.823Z",
    fill: "#D1D3D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M173.084 116.094C173.084 150.871 144.892 179.063 110.115 179.063C103 179.063 91.6378 177.644 91.0002 177C90.3626 176.356 93.1849 166.352 94.0003 163.5C96 157 96 156 102 143.5C108 131 123 112 140.5 101C148.641 95.8833 158.5 91 166 88.5C168 91 173.084 95.8123 173.084 116.094Z",
    fill: "#D1D3D4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M330.877 372.446C329.315 370.884 329.315 368.351 330.877 366.789L364.038 333.628C365.6 332.066 368.132 332.066 369.695 333.628L464.027 427.96C473.399 437.333 473.399 452.529 464.027 461.901L459.15 466.778C449.778 476.15 434.582 476.15 425.209 466.778L330.877 372.446Z",
    fill: "#D1D3D4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.729,
    cy: 182.292,
    r: 12.9167,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.74,
    cy: 138.698,
    r: 20.9896,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 433,
    cy: 249,
    r: 31,
    fill: "#D1D3D4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 389,
    cy: 218,
    r: 15,
    fill: "#D1D3D4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 147.833,
    cy: 406.833,
    r: 25.8334,
    fill: "#D1D3D4"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 413.219,
    cy: 52.2188,
    r: 24.2188,
    fill: "#D1D3D4"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 84,
    cy: 419,
    r: 53,
    fill: "#D1D3D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingError);
export default __webpack_public_path__ + "static/media/Loading_error.17e23246ab0d00cc5e0d19ad37e0dc98.svg";
export { ForwardRef as ReactComponent };